import { Ionicons } from "@expo/vector-icons";
import { router } from "expo-router";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Text, Pressable } from "react-native";
import { useDispatch } from "react-redux";

import { clearAllValues } from "@/context/actions/actions";
import { getUserStorage, storage } from "@/context/storage";

export default function ButtonLogout() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isHovered, setIsHovered] = useState(false);

  const handlePress = () => {
    const currentUserId = storage.getString("user.auth.userId");
    const userStorage = getUserStorage(currentUserId);
    storage.clearAll();
    userStorage.clearAll();
    dispatch(clearAllValues());
    router.replace("/");
  };

  return (
    <Pressable
      className="flex-row items-center justify-center"
      onPress={handlePress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
    >
      <Ionicons
        name="log-out-outline"
        size={24}
        color={isHovered ? "#5D0CBA" : "#919191"}
      />
      <Text
        className={`${isHovered ? "text-purple1" : "text-darkergray"} ml-2`}
      >
        {t("common:button.logout")}
      </Text>
    </Pressable>
  );
}
